<template>
  <multiple_form
    :forms="forms"
    :edit="true"
    :editData="props.editData"
    :disabled="true"
    :submitBtn="false"
    :labelCol="{ span: 9 }"
    :isScroll="false"
  />
</template>
<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import { message } from 'ant-design-vue'
  import { approval } from '@/api/transport/transport_approval'
  import multiple_form from '@/components/multiple_form'
  import { cityDelivery, transportType } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'
  //初始化
  const props = defineProps({
    editData: Object,
    data: Array,
    idField: String,
  })
  const emit = defineEmits(['submit'])

  //表单
  const forms = computed(() => [
    {
      name: '运单信息',
      id: 'transport',
      formItem: [
        {
          type: 'input',
          field: 'application_number',
          label: '运单受理单号',
        },
        {
          type: 'radio',
          field: 'transport_type',
          options: constantToOptions(transportType),
          label: '运货类型',
        },
        {
          type: 'input',
          field: 'list_number',
          label: '运单编号（国家统一运单编号）',
        },
        {
          type: 'input',
          field: 'cargo_name',
          label: '货物名称',
        },
        {
          type: 'input',
          field: 'cargo_quantity',
          label: '货物数量',
        },
        {
          type: 'input',
          field: 'cargo_unit',
          label: '货物单位（吨）',
        },
        {
          type: 'input',
          field: 'enterprise',
          label: '承运方企业名称',
        },
        {
          type: 'input',
          field: 'unified_social_credit_code',
          label: '承运方企业统一信用代码',
        },
        {
          type: 'input',
          field: 'business_license_number',
          label: '承运方企业经营许可证号',
        },
        {
          type: 'input',
          field: 'contact_phone',
          label: '承运人联系电话',
        },
        {
          type: 'input',
          field: 'contact_phone',
          label: '承运人联系电话',
        },
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
        },
        {
          type: 'input',
          field: 'license_plate_color',
          label: '车辆号牌颜色',
        },
        {
          type: 'input',
          field: 'vehicle_transport_license',
          label: '车辆道路运输证号',
        },
        {
          type: 'input',
          field: 'trailer_license',
          label: '挂车号牌',
          required: false,
        },
        {
          type: 'input',
          field: 'trailer_transport_license',
          label: '挂车道路运输证号',
          required: false,
        },
        {
          type: 'input',
          field: 'tank_volume',
          label: '罐体容积(m³)',
          required: false,
        },
        /*{
          type: 'input',
          field: 'tank_number',
          label: '罐体编号',
          required: false,
        },*/
        /*{
          type: 'input',
          field: 'tank_truck_dimensions',
          label: '槽罐车尺寸',
        },*/
        {
          type: 'input',
          field: 'driver',
          label: '驾驶员姓名',
        },
        {
          type: 'input',
          field: 'driver_phone',
          label: '驾驶员联系方式',
        },
        {
          type: 'input',
          field: 'driver_qualification_certificate',
          label: '驾驶员从业资格证号',
        },
        /*{
          type: 'input',
          field: 'driver_qc_validity_start',
          label: '驾驶员从业资格证有效开始日期',
        },
        {
          type: 'input',
          field: 'driver_qc_validity_end',
          label: '驾驶员从业资格证有效结束日期',
        },*/
        {
          type: 'input',
          field: 'supercargo',
          label: '押运员姓名',
        },
        {
          type: 'input',
          field: 'supercargo_phone',
          label: '押运员联系方式',
        },
        {
          type: 'input',
          field: 'supercargo_qualification_certificate',
          label: '押运员从业资格证号',
        },
        /*{
          type: 'input',
          field: 'supergo_qc_validity_start',
          label: '押运员从业资格证有效开始日期',
        },
        {
          type: 'input',
          field: 'supergo_qc_validity_end',
          label: '押运员从业资格证有效结束日期',
        },*/
        {
          type: 'input',
          field: 'shipper',
          label: '托运人姓名',
        },
        {
          type: 'input',
          field: 'shipper_phone',
          label: '托运人联系电话',
        },
        /*{
          type: 'input',
          field: 'shipper_bln',
          label: '托运人公司经营许可证号',
        },*/
        {
          type: 'input',
          field: 'recipient',
          label: '收货人姓名',
        },
        {
          type: 'input',
          field: 'recipient_phone',
          label: '收货人联系电话',
        },
        {
          type: 'input',
          field: 'carrier',
          label: '装货人姓名',
        },
        {
          type: 'input',
          field: 'carrier_phone',
          label: '装货人联系电话',
        },
        /*{
          type: 'input',
          field: 'dispatcher',
          label: '调度人姓名',
        },
        {
          type: 'input',
          field: 'dispatcher_start_time',
          label: '调度开始时间',
        },
        {
          type: 'input',
          field: 'dispatcher_end_time',
          label: '调度结束时间',
        },*/
        {
          type: 'input',
          field: 'shipment_date',
          label: '起运日期',
        },
        {
          type: 'input',
          field: 'shipment_addr',
          // label: '起运地',
          label: props.editData.transport_type == 1 ? '起运地' : '起运地(省/市/区+详细地址)',
        },
        {
          type: 'input',
          field: 'destination',
          // label: '目的地(省/市/区+详细地址)',
          label: props.editData.transport_type == 1 ? '目的地(省/市/区+详细地址)' : '目的地',
        },
        /*{
          type: 'radio',
          field: 'city_delivery',
          options: constantToOptions(cityDelivery),
          label: '是否城市配送',
        },*/
        {
          type: 'image',
          field: 'annex',
          label: '运单附件（国家统一运单的图片）',
        },
      ],
    },
  ])
</script>